import Image from 'next/image';
import Link from 'next/link';
import React, { Component, Fragment } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import { Modal } from 'react-responsive-modal';
import { useRouter } from 'next/router';
import toast from 'react-hot-toast';

import getPlateVinInfo from '../../functions/getPlateVinInfo';
import ProvinceInput from '../checkout/components/Address/ProvinceField/province-field';
import Dropdown from '../checkout/components/Dropdown/Country/dropdown';
import TextInput from '../checkout/components/TextInput/text-input';
import whereToFindVin from "@src/static/images/where-to-find-vin.jpg";

export default class LicensePlate extends Component {
	constructor(props) {
		super(props);

		this.state = {
			country_code: props.geolocation ? props.geolocation.country : 'US',
			state_or_province_code: props.geolocation ? props.geolocation.state : '',
			state_or_province: '',
			license_plate: '',
			vin_number: '',
			searching: false,
			showLink: false,
			SuggestedUrl: ``,
			imgUrl: '',
			carDetails: '',
			visibleWhereToFindVin: false
		};
		this._validateOnDemand = false;
		this.validator = new SimpleReactValidator({
			locale: 'en',
			autoForceUpdate: this,
		});

		this.validatorVin = new SimpleReactValidator({
			locale: 'en',
			autoForceUpdate: this,
		});

		this.lookupLicensePlate = this.lookupLicensePlate.bind(this);
	}

	async lookupVIN() {
		if (this.validatorVin.allValid()) {
			this.setState({ searching: true });
			var plateResult = await getPlateVinInfo({
				state: 'CA',
				plate: this.state.vin_number,
			});
			this.setState({ searching: false });
			if (plateResult.vehicle) {
				this.props.setVin(this.state.vin_number);
				
				if (plateResult.vehicle.SuggestedUrl) {
					this.setState({
						showLink: true,
						imgUrl: plateResult.vehicle.ImageBase64,
						SuggestedUrl: `${plateResult.vehicle.SuggestedUrl}`,
						carDetails: plateResult.vehicle.SearchString,
					});
				}

				else {
					this.props.changeVisibility('initial');
					toast.error('Error Retrieving Vehicle Information. Please Select Your Vehicle Manually.');
				}
			}

		} else {
			this.validatorVin.showMessages();
			this.forceUpdate();
			return false;
		}
		this.setState({ searching: false });
	}

	async lookupLicensePlate() {

		if (this.validator.allValid()) {
			this.setState({ searching: true });
			var plateResult = await getPlateVinInfo({
				state: this.state.state_or_province_code,
				plate: this.state.license_plate,
			});

			this.setState({ searching: false });
			if (plateResult.vehicle) {
				this.props.setVin(plateResult.vehicle.VechileIdentificationNumber);
				if (plateResult.vehicle.SuggestedUrl) {
					this.setState({
						showLink: true,
						imgUrl: plateResult.vehicle.ImageBase64,
						SuggestedUrl: `${plateResult.vehicle.SuggestedUrl}`,
						carDetails: plateResult.vehicle.SearchString,
					});
				}
			}
		} else {
			this.validator.showMessages();
			this.forceUpdate();
			return false;
		}
		this.setState({ searching: false });
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.country_code != this.state.country_code) {
			var country = this.props.countries.find(
				({ country_iso2 }) => country_iso2 === this.state.country_code // Probably Grab from Geolocation ( Country and State...)
			);
			if (country.country_iso2 == this.props.geolocation.country) {
				this.setState({ state_or_province_code: this.props.geolocation.state });
			} else {
				if (country.states.length > 0) {
					this.setState({ state_or_province_code: country.states[0].state_abbreviation });
				} else {
					this.setState({ state_or_province_code: null });
				}
			}
		}
	}

	render() {
		if (!this.props.countries) {
			return '';
		}

		const validator = this.validator;
		const validatorVin = this.validatorVin;
		const { searching } = this.state.searching;
		var country = this.props.countries.find(({ country_iso2 }) => country_iso2 === this.state.country_code);

		var button_disabled = false;

		var thumb_image = 'california-license-thumb.jpg';
		var plate_url =
			'https://1800battery-dev-hostingbucket-dev.s3-us-west-2.amazonaws.com/assets/images/plates/' + thumb_image;
		let carIMGURL = this.state.imgUrl;

		if (country) {
			var state_code = country.states.find(
				({ state_abbreviation }) => state_abbreviation === this.state.state_or_province_code
			);

			if (state_code) {
				plate_url = `https://cdn.findbyplate.com/${country.country_iso2}/${this.state.state_or_province_code}/${this.state.license_plate}.jpg`;

				if (country.country_iso2 == 'CA') {
					button_disabled = true;
					var statename = state_code.state.replace(/\s/g, '');
					thumb_image = `${statename}-license-thumb.jpg`.toLowerCase();
					plate_url =
						'https://1800battery-dev-hostingbucket-dev.s3-us-west-2.amazonaws.com/assets/images/plates/' +
						thumb_image;
				}
			}
		}
		return (
			<Fragment>        
				<Modal open={this.props.visibleQuickSearchTab !== 'initial'} onClose={() => this.props.changeVisibility('initial')} classNames={{root: 'license-vin-container'}}>
				<div>
					<div className="header">
						<div className="nav">
							<button className={`btn ${this.props.visibleQuickSearchTab === 'license' && 'active'}`} onClick={() => {
								this.props.changeVisibility('license')
							}
							}>License Plate Search</button>
							<button className={`btn ${this.props.visibleQuickSearchTab === 'vin' && 'active'}`}  onClick={() => {
								this.props.changeVisibility('vin')
							}}>VIN Search</button>
						</div>
					</div>

					<Fragment>
						<div>
							{this.props.visibleQuickSearchTab === 'vin' && (
								<div className="license-plate-search-container">
									<div className="license-plate-search">

										<div className="right-container">
											<h3>Search by VIN</h3> 
											<p>We will show the personalized results for your Car or Truck.</p>
												
											<div className="form-container">
												<span className="form-input-title">VIN Number</span>
												<div className="form-item">
													<TextInput
														id="licensePlate"
														label={'License Plate'}
														value={this.state.vin_number}
														placeholder="For example 1GYUKAEF4AR112337..."
														onChange={({ target }) => {
															console.log(this.state);
															this.setState({ vin_number: target.value })
														}}
													/>

													{validatorVin.message('input', this.state.vin_number, 'required|min:16|max:17')}
												</div>

												<button
													disabled={searching}
													className="block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 bg-[#0ebcee] text-white shadow-sm hover:bg-[#0889ad] w-100 border-none"
													aria-label="search-license-plate"
													onClick={() => this.lookupVIN()}>
													<i
														className={
															this.state.searching ? 'fas fa-circle-notch fa-spin me-4' : 'fas fa-search me-4'
														}
													/>
													{button_disabled ? 'Not Available' : 'Search'}
												</button>

												<div className="where-to-find-vin mt-3">
													<button style={{textDecoration: 'underline'}} className="d-block mb-2 text-decoration-underline" onClick={() => this.setState({visibleWhereToFindVin: !this.state.visibleWhereToFindVin})}>Where to find VIN</button>

													{this.state.visibleWhereToFindVin && (
														<div>
															<p>The Vehicle Identification Number (VIN) that belongs to your vehicle, can be traced on various documents such as the title, registration, and insurance policy. Additionally, you can spot the VIN imprinted in various spots on the car itself, including:</p>
															<img className="mt-2" src={whereToFindVin.src} alt="Where to Find VIN" />
															<button onClick={() => this.setState({visibleWhereToFindVin: false})} className="btn-secondary rounded p-2 w-100 mt-4 btn-outline">OK</button>
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
							)}

							{this.props.visibleQuickSearchTab === 'license' && (
								<div className="license-plate-search-container">
								<div className="license-plate-search">
									<div className="preview-container position-relative">
										<Image
											className="smaller-thumb"
											src={plate_url}
											alt="License Plate"
											width="200px"
											height="100px"
											layout="responsive"
										/>
									</div>

									<div className="right-container">
										<h3>Search License Plate or VIN</h3> 
										<p>We will show the personalized results for your Car or Truck.</p>
											
										<div className="form-container">
										<span className="form-input-title">Country</span>
											<div className="form-item">
												<Dropdown
													id={`country_code`}
													label={'Country'}
													value={this.state.country_code}
													onChange={({ target }) => this.setState({ country_code: target.value })}
													options={this.props.countries}
												/>

												{validator.message('Country', this.state.country_code, 'required')}
											</div>

											<span className="form-input-title">State</span>
											<div className="form-item">
												<ProvinceInput
													name={this.props.name}
													country={country}
													stateOrProvince={this.state.state_or_province}
													stateOrProvinceCode={this.state.state_or_province_code}
													onChange={({ target }) =>
														this.setState({ state_or_province: target.value })
													}
													onCodeChange={({ target }) => {
														var state_name = country.states.find(
															({ state_abbreviation }) => state_abbreviation === target.value
														);
														this.setState({
															state_or_province: state_name.state,
															state_or_province_code: target.value,
														});
													}}
												/>

												{validator.message(
													'State or Province',
													this.state.state_or_province || this.state.state_or_province_code,
													'required'
												)}
											</div>

											<span className="form-input-title">license Plate</span>
											<div className="form-item">
												<TextInput
													id="licensePlate"
													label={'License Plate'}
													value={this.state.license_plate}
													placeholder="Enter your license plate..."
													onChange={({ target }) => this.setState({ license_plate: target.value })}
												/>

												{validator.message('license Plate', this.state.license_plate, 'required')}
											</div>

											<button
												disabled={button_disabled ? true : searching}
												className="block rounded-md py-2 px-3 text-center text-sm font-semibold leading-6 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 bg-[#0ebcee] text-white shadow-sm hover:bg-[#0889ad] w-100 border-none"
												aria-label="search-license-plate"
												onClick={() => this.lookupLicensePlate()}>
												<i
													className={
														this.state.searching ? 'fas fa-circle-notch fa-spin me-4' : 'fas fa-search me-4'
													}
												/>
												{button_disabled ? 'Not Available' : 'Search'}
											</button>
										</div>
									</div>
								</div>
							</div>
							)}

							{this.state.showLink && this.state.imgUrl !== '' && (
								<>
									<SearchResults 
										changeVisibility = {this.props.changeVisibility}
										searching = {this.state.searching}
										carDetails = {this.state.carDetails}
										carIMGURL = {carIMGURL}
										suggestedUrl = {this.state.SuggestedUrl}
									/>
								</>
							)}
						</div>
					</Fragment>
				</div>
				</Modal>
			</Fragment>
		);
	}
}

function SearchResults(props) {
	const {searching, carDetails, carIMGURL, suggestedUrl} = props;
	const router = useRouter()

	return(
		<div className="license-plate-search-result">
			<div className="content">
				{carIMGURL && carIMGURL !== '' && (
					<Image
						className="img"
						src={`data:image/png;base64, ${carIMGURL}`}
						alt="car"
						width="150px"
						height="100px"
					/>
				)}
				<div className="text">
					<p>Your Vehicle</p>
					<h6>{carDetails}</h6>
					<div className="button-container">
						<button 
							className="btn"
							disabled={searching}
							id="linktoPage"
							onClick={() => {
								props.changeVisibility('initial');
								router.push((`/category/[categoryid]?categoryid=${suggestedUrl}`,
								`/${suggestedUrl}`))
							}}
						>
							Select Vehicle
						</button>
						
					</div>
				</div>
			</div>
			
		</div>
	)
}
